<template>
  <section v-if="chatBotEdit">
    <b-modal width="680px" :active.sync="chatBotEdit">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <p class="card-header-title">
            {{ chatbots[editIndex].name }}を編集しています
          </p>
        </header>
        <div class="card-content">
          <b-field label="Bot名">
              <b-input v-model="chatbots[editIndex].name"></b-input>
          </b-field>
          <b-field label="シナリオ名">
            <b-select v-model="chatbots[editIndex].scenario_name" expanded>
              <option v-for="(s, index) in chatbots" :key="index" :value="s.scenario_name">{{ s.name }}</option>
            </b-select>
          </b-field>
          <b-field label="起動URL">
              <b-input v-model="chatbots[editIndex].target_url"></b-input>
          </b-field>
          <hr>
          <button class="button is-primary is-fullwidth" v-if="isCheck" @click="editChatBot()">
            決定する
          </button>
          <button class="button is-primary is-fullwidth" v-if="!isCheck" disabled>
            決定する
          </button>
        </div>
      </div>
    </b-modal>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import ScenarioList from '@/views/DashBoard/ChatBot/ScenarioList'
export default {
  name: 'ModalEditChatBot',
  componentName: 'ModalEditChatBot',
  components: {
    ScenarioList
  },
  props: {
    editIndex: Number,
    originalChatBot: Object
  },
  computed: {
    ...mapState('chatbot', ['chatbots']),
    ...mapState('auth', ['user']),
    isCheck () {
      return this.chatbots[this.editIndex].name !== '' && this.chatbots[this.editIndex].scenario_name !== ''
    }
  },
  data () {
    return {
      chatBotEdit: false,
      editedChatBot: ''
    }
  },
  methods: {
    editChatBot () {
      console.debug('*** Start *** editChatBot')
      this.chatBotEdit = false
      this.$store.dispatch('chatbot/setChatBot', this.chatbots[this.editIndex])
      console.debug('*** End *** editChatBot')
    },
    editCancel () {
      console.debug('*** Start *** editCancel')
      this.chatBotEdit = false
      Object.assign(this.chatbots[this.editIndex], this.originalChatBot)
      console.debug('*** End *** editCancel')
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ui/ModalEditChatBot.vue